module.exports = __webpack_public_path__ + "static/media/section-6-1.08ed5195.svg";